import { useState } from 'react';

import { LinkIcon } from '../../layout/icons';
import { normalizeYoutubeUrl, youtubeThumbnailUrl, type YoutubeVideoReference } from '../link/youtube';
import { PlayTriangleIcon, YoutubeGlyph } from './panelGlyphs';

export interface InsertedYoutubeVideo extends YoutubeVideoReference {
  rawUrl: string;
}

export interface InsertLinkPanelProps {
  videos: InsertedYoutubeVideo[];
  onInsert: (video: InsertedYoutubeVideo) => void;
  onPlay: (video: InsertedYoutubeVideo) => void;
}

export function InsertLinkPanel({ videos, onInsert, onPlay }: InsertLinkPanelProps) {
  const [input, setInput] = useState('');
  const [error, setError] = useState('');

  function insert() {
    const video = normalizeYoutubeUrl(input);
    if (!video) {
      setError(input.trim() ? 'Liên kết YouTube không hợp lệ.' : 'Dán link YouTube trước khi chèn.');
      return;
    }
    setError('');
    onInsert({ ...video, rawUrl: input.trim() });
    setInput('');
  }

  return (
    <div className="yt-pane">
      <div className="yt-pane__field">
        <LinkIcon size={13} />
        <input
          value={input}
          onChange={(event) => { setInput(event.target.value); setError(''); }}
          onKeyDown={(event) => { if (event.key === 'Enter') { event.preventDefault(); insert(); } }}
          placeholder="Dán link YouTube…"
          aria-label="Dán link YouTube"
        />
      </div>
      <p className="yt-pane__hint">youtube.com/watch?v=… · youtu.be/…</p>
      {error ? <p className="yt-pane__error" role="alert">{error}</p> : null}
      <button type="button" className="yt-pane__insert" onClick={insert}>
        <YoutubeGlyph size={12} />
        <span>Chèn video</span>
      </button>

      {videos.length === 0 ? (
        <p className="yt-empty">Chưa có link nào</p>
      ) : (
        <section className="yt-list">
          <h3 className="yt-list__heading">Đã chèn ({videos.length})</h3>
          {videos.map((video) => (
            <button type="button" className="yt-card" key={`${video.id}-${video.start}`} aria-label={`Phát video ${video.rawUrl}`} title={video.rawUrl} onClick={() => onPlay(video)}>
              <span className="yt-card__thumb">
                <img src={youtubeThumbnailUrl(video.id)} alt="" />
                <span className="yt-card__scrim" aria-hidden={true} />
                <span className="yt-card__play" aria-hidden={true}><PlayTriangleIcon size={15} /></span>
              </span>
              <span className="yt-card__url">
                <YoutubeGlyph size={12} />
                <span>{video.rawUrl}</span>
              </span>
            </button>
          ))}
        </section>
      )}
    </div>
  );
}
